// import React, { useState } from "react";
// import Sidebar from "./Sidebar";
// import TopPanel from "./TopPanel";
// import Footer from "./Footer";

// function ReviewQueue() {
//   const [loading, setLoading] = useState(false);

//   // Table Data based on the image
//   const queueData = [
//     {
//       badgeText: "Promo used before refund",
//       badgeType: "promo",
//       id: "RC-00212",
//       customer: "Aditya Rao",
//       campaign: "Recharge ₹3,000 → ₹200",
//       whatHappened: "Recharge of ₹3,000 refunded on 22 Sep. ₹140 of the ₹200 promo was already spent; ₹60 reversed automatically.",
//       amount: "₹140",
//       suggestedAction: "Recover from next recharge or write off"
//     },
//     {
//       badgeText: "Refund after referral reward",
//       badgeType: "refund",
//       id: "RC-00209",
//       customer: "Sanjay Kulkarni",
//       campaign: "Refer & Earn · ₹500 + ₹500",
//       whatHappened: "Qualifying ₹3,000 recharge refunded after both rewards were issued. Referee subscription cancelled.",
//       amount: "₹1,000",
//       suggestedAction: "Reverse unused referee credit; decide on referrer reward"
//     },
//     {
//       badgeText: "Referral check failed",
//       badgeType: "referral",
//       id: "RC-00207",
//       customer: "Rahul Sharma",
//       campaign: "Refer & Earn · ₹500 + ₹500",
//       whatHappened: "Same flat + building as referrer (Flat 1204, Tower B, Green Valley). Customer says a relative moved out.",
//       amount: "₹1,000",
//       suggestedAction: "Keep ineligible unless address proof differs"
//     },
//     {
//       badgeText: "Promo used before refund",
//       badgeType: "promo",
//       id: "RC-00205",
//       customer: "Neelam Joshi",
//       campaign: "Recharge ₹5,000 → ₹400",
//       whatHappened: "Partial refund ₹5,000 → ₹2,000 kept. Recharge now below minimum; ₹400 promo fully spent.",
//       amount: "₹400",
//       suggestedAction: "Accounts decision"
//     }
//   ];

//   // Helper for dynamic badge styling
//   const renderCaseBadge = (text, type) => {
//     let bgColor = "#f1f3f5";
//     let textColor = "#495057";

//     if (type === "promo") {
//       bgColor = "#faebd7"; // Light orange/peach
//       textColor = "#a0522d"; // Brownish text
//     } else if (type === "refund") {
//       bgColor = "#f8d7da"; // Light red
//       textColor = "#721c24"; // Dark red text
//     } else if (type === "referral") {
//       bgColor = "#f3e8ff"; // Light purple
//       textColor = "#5a3b75"; // Dark purple text
//     }

//     return (
//       <span style={{ backgroundColor: bgColor, color: textColor, padding: "5px 12px", borderRadius: "15px", fontSize: "14px", fontWeight: "700", display: "inline-block", marginBottom: "4px" }}>
//         {text}
//       </span>
//     );
//   };

//   // Filter Pill Component
//   const FilterPill = ({ text, active = false }) => (
//     <div style={{
//       backgroundColor: active ? "#3b5e40" : "#ffffff",
//       color: active ? "#ffffff" : "#495057",
//       border: active ? "1px solid #3b5e40" : "1px solid #ced4da",
//       padding: "6px 16px",
//       borderRadius: "20px",
//       fontSize: "16px",
//       fontWeight: "600",
//       cursor: "pointer"
//     }}>
//       {text}
//     </div>
//   );

//   return (
//     <>
//       {loading && (
//         <div className="loader-overlay">
//           <div><img style={{ height: "6rem" }} src="images/loader.gif" alt="loader" /></div>
//         </div>
//       )}
//       <div className="container-scroller" style={{ backgroundColor: "#f9f7f2" }}>
//         <TopPanel />
//         <div className="container-fluid page-body-wrapper">
//           <Sidebar />
//           <div className="main-panel" style={{ backgroundColor: "#f9f7f2", minHeight: "100vh" }}>
//             <div className="content-wrapper" style={{ padding: "2rem" }}>
              
//               {/* Header Section */}
//               <div className="d-flex justify-content-between align-items-end mb-4">
//                 <div>
//                   <h2 style={{ fontWeight: "700", fontFamily: "serif", color: "#2c2c2c", margin: "0 0 8px 0",fontSize:"30px" }}>Review Queue</h2>
//                   <p style={{ color: "#6c757d", fontSize: "16px", margin: 0 }}>
//                     Cases the system could not settle automatically. Phase 1 has no automated clawback of spent promotional credit.
//                   </p>
//                 </div>
//                 <div className="d-flex gap-2">
//                   <FilterPill text="Open - 4" active={true} />
//                   <FilterPill text="Resolved - 31" />
//                   <FilterPill text="Auto-reversed - 18" />
//                 </div>
//               </div>

//               {/* Table Section */}
//               <div className="card shadow-sm mb-4" style={{ borderRadius: "10px", border: "1px solid #e0e0e0" }}>
//                 <div className="card-body p-0">
//                   <div className="table-responsive">
//                     <table className="table table-hover mb-0" style={{ fontSize: "13px" }}>
//                       <thead style={{ color: "#8a8a8a", fontSize: "11px", letterSpacing: "0.5px", fontWeight: "bold", borderBottom: "2px solid #e0e0e0" }}>
//                         <tr>
//                           <th className="pt-3 pb-3 ps-4 border-0" style={{ width: "18%" }}>CASE</th>
//                           <th className="pt-3 pb-3 border-0" style={{ width: "10%" }}>CUSTOMER</th>
//                           <th className="pt-3 pb-3 border-0" style={{ width: "15%" }}>CAMPAIGN</th>
//                           <th className="pt-3 pb-3 border-0 text-wrap" style={{ width: "8%" }}>WHAT HAPPENED</th>
//                           <th className="pt-3 pb-3 border-0 text-end" style={{ width: "10%" }}>AMOUNT AT<br/>STAKE</th>
//                           <th className="pt-3 pb-3 border-0 ps-4" style={{ width: "5%" }}>SUGGESTED ACTION</th>
//                           <th className="pt-3 pb-3 border-0 text-end pe-4" style={{ width: "10%" }}>ACTIONS</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {queueData.map((row, idx) => (
//                           <tr key={idx} style={{ verticalAlign: "top" }}>
//                             {/* Case */}
//                             <td className="ps-4 py-4">
//                               {renderCaseBadge(row.badgeText, row.badgeType)}
//                               <div style={{ fontSize: "13px", color: "#8a8a8a", fontFamily: "monospace", marginTop: "4px" }}>{row.id}</div>
//                             </td>
//                             {/* Customer */}
//                             <td className="py-4">
//                               <div style={{ fontWeight: "700", color: "#2c2c2c" }}>{row.customer.split(' ')[0]}<br/>{row.customer.split(' ')[1]}</div>
//                             </td>
//                             {/* Campaign */}
//                             <td className="py-4 text-muted" style={{ paddingRight: "15px" }}>
//                               {row.campaign}
//                             </td>
//                             {/* What Happened */}
//                             <td className="py-4" style={{ lineHeight: "1.5", paddingRight: "20px" }}>
//                               {row.whatHappened}
//                             </td>
//                             {/* Amount at Stake */}
//                             <td className="py-4 text-end">
//                               <span style={{ fontWeight: "700", color: "#a56627", fontSize: "14px" }}>{row.amount}</span>
//                             </td>
//                             {/* Suggested Action */}
//                             <td className="py-4 text-muted ps-4" style={{ lineHeight: "1.5" }}>
//                               {row.suggestedAction}
//                             </td>
//                             {/* Actions */}
//                             <td className="py-4 text-end pe-4">
//                               <div className="d-flex flex-column align-items-end gap-2">
//                                 <button className="btn btn-sm text-white" style={{ backgroundColor: "#3b5e40", fontWeight: "600", borderRadius: "6px", width: "100px" }}>
//                                   Resolve
//                                 </button>
//                                 <button className="btn btn-sm btn-light border" style={{ backgroundColor: "#ffffff", color: "#495057", fontWeight: "600", borderRadius: "6px", width: "100px" }}>
//                                   Adjust wallet
//                                 </button>
//                               </div>
//                             </td>
//                           </tr>
//                         ))}
//                       </tbody>
//                     </table>
//                   </div>
//                 </div>
//               </div>

//               {/* Explanatory Legend / Footer Card */}
//               <div className="card shadow-sm" style={{ borderRadius: "10px", border: "1px solid #e0e0e0" }}>
//                 <div className="card-body p-4">
//                   <div className="row">
//                     <div className="col-md-4 pe-4">
//                       <h6 style={{ fontWeight: "700", color: "#2c2c2c", marginBottom: "8px",fontSize:"18px" }}>Resolve</h6>
//                       <p style={{ fontSize: "14px", color: "#6c757d", margin: 0, lineHeight: "1.5" }}>
//                         Close with a note (e.g. written off, recovered on next recharge). Stored on the case and in the audit log.
//                       </p>
//                     </div>
//                     <div className="col-md-4 px-4">
//                       <h6 style={{ fontWeight: "700", color: "#2c2c2c", marginBottom: "8px",fontSize:"18px" }}>Adjust wallet</h6>
//                       <p style={{ fontSize: "14px", color: "#6c757d", margin: 0, lineHeight: "1.5" }}>
//                         Accounts posts a manual ledger entry through the function, linked to the case and the campaign.
//                       </p>
//                     </div>
//                     <div className="col-md-4 ps-4">
//                       <h6 style={{ fontWeight: "700", color: "#2c2c2c", marginBottom: "8px",fontSize:"18px" }}>Auto-reversed</h6>
//                       <p style={{ fontSize: "14px", color: "#6c757d", margin: 0, lineHeight: "1.5" }}>
//                         Refunds where the promo credit was still unused are reversed by the system and only logged here.
//                       </p>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//             </div>
//             <Footer />
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export default ReviewQueue;


import React, { useState } from "react";
import Sidebar from "./Sidebar";
import TopPanel from "./TopPanel";
import Footer from "./Footer";

function ReviewQueue() {
  const [loading, setLoading] = useState(false);

  // Table Data based on the image
  const queueData = [
    {
      badgeText: "Promo used before refund",
      badgeType: "promo",
      id: "RC-00212",
      customer: "Aditya Rao",
      campaign: "Recharge ₹3,000 → ₹200",
      whatHappened: "Recharge of ₹3,000 refunded on 22 Sep. ₹140 of the ₹200 promo was already spent; ₹60 reversed automatically.",
      amount: "₹140",
      suggestedAction: "Recover from next recharge or write off"
    },
    {
      badgeText: "Refund after referral reward",
      badgeType: "refund",
      id: "RC-00209",
      customer: "Sanjay Kulkarni",
      campaign: "Refer & Earn · ₹500 + ₹500",
      whatHappened: "Qualifying ₹3,000 recharge refunded after both rewards were issued. Referee subscription cancelled.",
      amount: "₹1,000",
      suggestedAction: "Reverse unused referee credit; decide on referrer reward"
    },
    {
      badgeText: "Referral check failed",
      badgeType: "referral",
      id: "RC-00207",
      customer: "Rahul Sharma",
      campaign: "Refer & Earn · ₹500 + ₹500",
      whatHappened: "Same flat + building as referrer (Flat 1204, Tower B, Green Valley). Customer says a relative moved out.",
      amount: "₹1,000",
      suggestedAction: "Keep ineligible unless address proof differs"
    },
    {
      badgeText: "Promo used before refund",
      badgeType: "promo",
      id: "RC-00205",
      customer: "Neelam Joshi",
      campaign: "Recharge ₹5,000 → ₹400",
      whatHappened: "Partial refund ₹5,000 → ₹2,000 kept. Recharge now below minimum; ₹400 promo fully spent.",
      amount: "₹400",
      suggestedAction: "Accounts decision"
    }
  ];

  // Helper for dynamic badge styling
  const renderCaseBadge = (text, type) => {
    let bgColor = "#f1f3f5";
    let textColor = "#495057";

    if (type === "promo") {
      bgColor = "#faebd7"; // Light orange/peach
      textColor = "#a0522d"; // Brownish text
    } else if (type === "refund") {
      bgColor = "#f8d7da"; // Light red
      textColor = "#721c24"; // Dark red text
    } else if (type === "referral") {
      bgColor = "#f3e8ff"; // Light purple
      textColor = "#5a3b75"; // Dark purple text
    }

    return (
      <span style={{ backgroundColor: bgColor, color: textColor, padding: "5px 12px", borderRadius: "15px", fontSize: "14px", fontWeight: "700", display: "inline-block", marginBottom: "4px" }}>
        {text}
      </span>
    );
  };

  // Filter Pill Component
  const FilterPill = ({ text, active = false }) => (
    <div style={{
      backgroundColor: active ? "#3b5e40" : "#ffffff",
      color: active ? "#ffffff" : "#495057",
      border: active ? "1px solid #3b5e40" : "1px solid #ced4da",
      padding: "6px 16px",
      borderRadius: "20px",
      fontSize: "16px",
      fontWeight: "600",
      cursor: "pointer"
    }}>
      {text}
    </div>
  );

  return (
    <>
      {loading && (
        <div className="loader-overlay">
          <div><img style={{ height: "6rem" }} src="images/loader.gif" alt="loader" /></div>
        </div>
      )}
      <div className="container-scroller" style={{ backgroundColor: "#f9f7f2" }}>
        <TopPanel />
        <div className="container-fluid page-body-wrapper">
          <Sidebar />
          <div className="main-panel" style={{ backgroundColor: "#f9f7f2", minHeight: "100vh" }}>
            <div className="content-wrapper" style={{ padding: "2rem" }}>
              
              {/* Header Section */}
              <div className="d-flex justify-content-between align-items-end mb-4">
                <div>
                  <h2 style={{ fontWeight: "700", fontFamily: "serif", color: "#2c2c2c", margin: "0 0 8px 0",fontSize:"30px" }}>Review Queue</h2>
                  <p style={{ color: "#6c757d", fontSize: "16px", margin: 0 }}>
                    Cases the system could not settle automatically. Phase 1 has no automated clawback of spent promotional credit.
                  </p>
                </div>
                <div className="d-flex gap-2">
                  <FilterPill text="Open - 4" active={true} />
                  <FilterPill text="Resolved - 31" />
                  <FilterPill text="Auto-reversed - 18" />
                </div>
              </div>

              {/* Table Section */}
              <div className="card shadow-sm mb-4" style={{ borderRadius: "10px", border: "1px solid #e0e0e0" }}>
                <div className="card-body p-0">
                  <div className="table-responsive">
                    <table className="table table-hover mb-0" style={{ fontSize: "13px" }}>
                      <thead style={{ color: "#8a8a8a", fontSize: "11px", letterSpacing: "0.5px", fontWeight: "bold", borderBottom: "2px solid #e0e0e0" }}>
                        <tr>
                          <th className="pt-3 pb-3 ps-4 border-0" style={{ width: "16%" }}>CASE</th>
                          <th className="pt-3 pb-3 border-0" style={{ width: "12%" }}>CUSTOMER</th>
                          <th className="pt-3 pb-3 border-0" style={{ width: "12%" }}>CAMPAIGN</th>
                          <th className="pt-3 pb-3 border-0 text-wrap" style={{ width: "15%" }}>WHAT HAPPENED</th>
                          <th className="pt-3 pb-3 border-0 text-end" style={{ width: "8%" }}>AMOUNT AT<br/>STAKE</th>
                          <th className="pt-3 pb-3 border-0 ps-4" style={{ width: "15%" }}>SUGGESTED ACTION</th>
                          <th className="pt-3 pb-3 border-0 text-end pe-4" style={{ width: "22%" }}>ACTIONS</th>
                        </tr>
                      </thead>
                      <tbody>
                        {queueData.map((row, idx) => (
                          <tr key={idx} style={{ verticalAlign: "top" }}>
                            {/* Case */}
                            <td className="ps-4 py-4">
                              {renderCaseBadge(row.badgeText, row.badgeType)}
                              <div style={{ fontSize: "13px", color: "#8a8a8a", fontFamily: "monospace", marginTop: "4px" }}>{row.id}</div>
                            </td>
                            {/* Customer (अब एक लाइन में) */}
                            <td className="py-4">
                              <div style={{ fontWeight: "700", color: "#2c2c2c", whiteSpace: "nowrap" }}>
                                {row.customer}
                              </div>
                            </td>
                            {/* Campaign */}
                            <td className="py-4 text-muted" style={{ paddingRight: "15px" }}>
                              {row.campaign}
                            </td>
                            {/* What Happened (Width कम और Text Wrap) */}
                            <td className="py-4 text-wrap" style={{ lineHeight: "1.5", paddingRight: "20px", minWidth: "300px", wordWrap: "break-word" }}>
                              {row.whatHappened}
                            </td>
                            {/* Amount at Stake */}
                            <td className="py-4 text-end">
                              <span style={{ fontWeight: "700", color: "#a56627", fontSize: "14px" }}>{row.amount}</span>
                            </td>
                            {/* Suggested Action (Width कम और Text Wrap) */}
                            <td className="py-4 text-muted ps-4 text-wrap" style={{ lineHeight: "1.5", maxWidth: "250px", wordWrap: "break-word" }}>
                              {row.suggestedAction}
                            </td>
                            {/* Actions (अब एक लाइन में) */}
                            <td className="py-4 text-end pe-4">
                              <div className="d-flex flex-row justify-content-end gap-2">
                                <button className="btn btn-sm text-white" style={{ backgroundColor: "#3b5e40", fontWeight: "600", borderRadius: "6px", whiteSpace: "nowrap" }}>
                                  Resolve
                                </button>
                                <button className="btn btn-sm btn-light border" style={{ backgroundColor: "#ffffff", color: "#495057", fontWeight: "600", borderRadius: "6px", whiteSpace: "nowrap" }}>
                                  Adjust wallet
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              {/* Explanatory Legend / Footer Card */}
              <div className="card shadow-sm" style={{ borderRadius: "10px", border: "1px solid #e0e0e0" }}>
                <div className="card-body p-4">
                  <div className="row">
                    <div className="col-md-4 pe-4">
                      <h6 style={{ fontWeight: "700", color: "#2c2c2c", marginBottom: "8px",fontSize:"18px" }}>Resolve</h6>
                      <p style={{ fontSize: "14px", color: "#6c757d", margin: 0, lineHeight: "1.5" }}>
                        Close with a note (e.g. written off, recovered on next recharge). Stored on the case and in the audit log.
                      </p>
                    </div>
                    <div className="col-md-4 px-4">
                      <h6 style={{ fontWeight: "700", color: "#2c2c2c", marginBottom: "8px",fontSize:"18px" }}>Adjust wallet</h6>
                      <p style={{ fontSize: "14px", color: "#6c757d", margin: 0, lineHeight: "1.5" }}>
                        Accounts posts a manual ledger entry through the function, linked to the case and the campaign.
                      </p>
                    </div>
                    <div className="col-md-4 ps-4">
                      <h6 style={{ fontWeight: "700", color: "#2c2c2c", marginBottom: "8px",fontSize:"18px" }}>Auto-reversed</h6>
                      <p style={{ fontSize: "14px", color: "#6c757d", margin: 0, lineHeight: "1.5" }}>
                        Refunds where the promo credit was still unused are reversed by the system and only logged here.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

            </div>
            <Footer />
          </div>
        </div>
      </div>
    </>
  );
}

export default ReviewQueue;